import React from "react";
import { useTranslation } from "react-i18next";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage";
import Header from "./componets/RedemptionOfGoodsHeader";
import FeatureWithSteps from "../../components/features/HowDoesItWorkPage5";
import Footer from "../../components/footers/MainFooterWithLinks";
import Explanation from "../../components/cards/JustExplanation";
import SectionApplication from "../../components/cta/ApplicationRedemption";
import "./componets/IncludedServicesSectionTariff.css";
import tw from "twin.macro";
import styled from "styled-components";
import Step1 from "../../images/img/Step1.svg";
import Step2 from "../../images/img/Step2.svg";
import Step3 from "../../images/img/PacageWoman.svg";

const StepHighlight = styled.span`
  ${tw`text-primary-500 font-bold`}
`;

const Prim = tw.span`text-center text-[#0ABD19] md:text-left text-xl`;

export default () => {
    const { t } = useTranslation();

    return (
        <AnimationRevealPage>
            <Header roundedHeaderButton={true} />
            <Explanation />
            <FeatureWithSteps
                heading={<>{t("redemption.howItWorks")}</>}
                plans={[
                    {
                        icon: Step1,
                        mainFeature: (
                            <>
                                <Prim>{t("redemption.step1Title")}</Prim> {t("redemption.step1Text")}
                            </>
                        ),
                    },
                    {
                        icon: Step2,
                        mainFeature: (
                            <>
                                <Prim>{t("redemption.step2Title")}</Prim> {t("redemption.step2Text")}
                            </>
                        ),
                    },
                    {
                        icon: Step3,
                        mainFeature: (
                            <>
                                <Prim>{t("redemption.step3Title")}</Prim> {t("redemption.step3Text")}
                            </>
                        ),
                    },
                ]}
            />
            <SectionApplication />
            <Footer />
        </AnimationRevealPage>
    );
};
